import { Routes, Route, BrowserRouter } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import React from 'react';
import Dashboard from '../pages/Dashboard';
import Error from '../pages/Error';
import Login from '../pages/Login';
import Captures from '../pages/Captures';
import QCPage from '../pages/QCPage';
import Testing from '../pages/Testing';
import UsersCaptures from '../pages/UsersCaptures';
import { AircraftQC } from '../pages/AircraftQC';
import { Info } from '../pages/Info';
import { Users } from '../pages/Users';
import Reports from '../pages/Reports';
import { QCVehicleDetection } from '../components/unused_comps/vehicle_qc/QCVehicleDetection';
import { DataChecks } from '../pages/DataChecks';
import { AdminPage } from '../pages/AdminPage';

const Router = ({ authProps }) => (
	<BrowserRouter>
		<Routes>
			<Route
				path="/"
				element={<ProtectedRoute authProps={authProps} component={Dashboard} />}
			/>

			<Route
				path="/aircraftqc"
				element={
					<ProtectedRoute authProps={authProps} component={AircraftQC} />
				}
			/>

			<Route
				path="/qc"
				element={<ProtectedRoute authProps={authProps} component={QCPage} />}
			/>

			<Route
				path="/info"
				element={<ProtectedRoute authProps={authProps} component={Info} />}
			/>

			<Route
				path="/capture"
				element={<ProtectedRoute authProps={authProps} component={Captures} />}
			/>

			<Route
				path="/captures"
				element={<ProtectedRoute authProps={authProps} component={Captures} />}
			/>

			<Route
				path="/testing"
				element={<ProtectedRoute authProps={authProps} component={Testing} />}
			/>

			<Route
				path="/users"
				element={<ProtectedRoute authProps={authProps} component={Users} />}
			/>

			<Route
				path="/vehicle_detection"
				element={
					<ProtectedRoute
						authProps={authProps}
						component={QCVehicleDetection}
					/>
				}
			/>

			<Route
				path="/reports"
				element={<ProtectedRoute authProps={authProps} component={Reports} />}
			/>

			<Route
				path="/scripts"
				element={<ProtectedRoute authProps={authProps} component={DataChecks} />}
			/>

			{/* <Route
				path="/admin"
				element={<ProtectedRoute authProps={authProps} component={AdminPage} />}
			/> */}

			{/* <Route
				path="/removecaps"
				element={
					<ProtectedRoute
						
						authProps={authProps}
						component={RemoveCaps}
						
					/>
				}
			/> */}

			<Route
				path="/users_captures"
				element={
					<ProtectedRoute authProps={authProps} component={UsersCaptures} />
				}
			/>

			<Route
				path="/404"
				element={<ProtectedRoute authProps={authProps} component={Error} />}
			/>

			<Route
				path="*"
				element={<ProtectedRoute authProps={authProps} component={Error} />}
			/>

			<Route path="/login" element={<Login {...authProps} />} />

			<Route
				path="*"
				element={<ProtectedRoute authProps={authProps} component={Error} />}
			/>
		</Routes>
	</BrowserRouter>
);

export default Router;
